import { IN_PERSON_TRAINING } from 'constants/actionTypes';

const initialState = {
  perPage: 10,
  page: 1,
  query: '',
  rsvpStatus: '',
  attendanceStatus: '',
  sort: {
    column: 'name',
    direction: 'asc',
  },
};

export default (filters = initialState, action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.ATTENDANCES.SET_FILTERS: {
      return {
        ...filters,
        ...action.payload,
        page: action.payload.page || 1,
      };
    }
    case IN_PERSON_TRAINING.ATTENDANCES.RESET_FILTERS:
      return initialState;
    default:
      return filters;
  }
};
